// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_3f8edbc4","outerContainer":"aa28e363","secondaryToolbar":"_9dccc5b5","doorHangerRight":"_1dca1dc5","toolbarContainer":"_3dd14c6f","toolbarViewerMiddle":"_9621fb81","progressBar":"e303674b","back-to-application":"_6bc82b25","canvas":"_3995c3f0","info":"_29d3a85c","empty":"_52a5d015","description":"_8a9b9b7a"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientHealthboard/PatientPortal/LabTestHistoryModal/EmptyWrapper/index.styl
// module id = 5057
// module chunks = 39